/*
 * Audiences section shell (redesign 2026-10-09, PlunkDocs mockups/audiences-redesign-2026-10-09.html):
 * one header (title, a line for the tab, extra actions + New list) and the Lists · Health · Duplicates · Suppression tabs.
 */
import React from "react";
import { withRouter } from "react-router";
import { Button } from "@progress/kendo-react-buttons";
import { PageHeader, Switcher } from "../../components/analytics-kit";
export const TABS = [{
  to: "/Audiences",
  label: "Lists",
  isActive: p => /^\/Audiences(?!\/(Duplicates|Suppression|Health))/i.test(p)
}, {
  to: "/Audiences/Health",
  label: "Health",
  isActive: p => /^\/Audiences\/Health/i.test(p)
}, {
  to: "/Audiences/Duplicates",
  label: "Duplicates",
  isActive: p => /^\/Audiences\/Duplicates/i.test(p)
}, {
  to: "/Audiences/Suppression",
  label: "Suppression",
  isActive: p => /^\/Audiences\/Suppression/i.test(p)
}];
export const SUBTITLES = {
  lists: "Groups of people you send to, show ads to or study",
  health: "How many people you can reach, and what to fix",
  duplicates: "People who are in your contacts twice",
  suppression: "Addresses that never get bulk email"
};

/** <AudiencesShell subtitle actions onNew>: onNew overrides the New list button (default: /Audiences?new=1); newList={false} hides it. */
function AudiencesShellComponent({
  title = "Audiences",
  subtitle,
  actions,
  children,
  cls = "",
  onNew,
  newList = true,
  history
}) {
  const newBtn = newList ? /*#__PURE__*/React.createElement(Button, {
    themeColor: "primary",
    onClick: () => onNew ? onNew() : history.push("/Audiences?new=1")
  }, "New list") : null;
  return /*#__PURE__*/React.createElement("div", {
    className: `territory-view wa-view audiences-view aud-mgmt aud-x ec-form ${cls}`
  }, /*#__PURE__*/React.createElement(PageHeader, {
    title: title,
    subtitle: subtitle,
    chips: [],
    actions: /*#__PURE__*/React.createElement(React.Fragment, null, actions, newBtn)
  }), /*#__PURE__*/React.createElement(Switcher, {
    items: TABS,
    ariaLabel: "Audience views"
  }), children);
}
const AudiencesShell = withRouter(AudiencesShellComponent);
export default AudiencesShell;